<template>
  <el-table-column
    prop="representative_order.receipt_number"
    sortable="custom"
    label="Kapcsolódó megrendelés"
    show-overflow-tooltip
    min-width="220"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.representative_order_receipt_number"
        style="display: inline-block;"
      >
        <receipt-link
          :id="scope.row.representative_order_id"
          :label="scope.row.representative_order_receipt_number"
          type="representativeOrder"
        />
      </div>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó megrendelés</el-tag>
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: { ReceiptLink },
  propName: 'representative_order.receipt_number',
};
</script>

